/* eslint-disable no-undef */
/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { object, array } from "prop-types";

import CardImageLarge from "../../molecules/card-image-large/index";
import SmallHorizontalCard from "../../molecules/small-horizontal-card/index";
import CustomHeadline from "../../molecules/custom-headline/index";
import DfpAd from "../../dfp-ad";

import { getSlug } from "../../utils";

import "./top-news.m.css";

class TopStoriesCollection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: null
    };
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  // setTimeoutForDFP = id => {
  //   setTimeout(() => this.dfpAd(id), 2500);
  // };

  componentDidMount() {
    // (window.adsbygoogle = window.adsbygoogle || []).push({});
    this.isWidthPresent();
  }

  // dfpAd(adsId) {

  //   return (
  //     <ins
  //       className="adsbygoogle"
  //       style={{ display: "inline-block", width: 300 + "px", height: 250 + "px" }}
  //       data-ad-client="ca-pub-9082438933551282"
  //       data-ad-slot={adsId}
  //       data-ad-test="on"
  //     />
  //   );
  // }

  render() {
    const { collection, sections } = this.props;
    const collectionStories = collection.items.filter(item => item.type === "story");
    const areStoriesPresent = collectionStories && collectionStories.length > 0;
    const firstItem = areStoriesPresent && collectionStories[0];
    const secondItem = areStoriesPresent && collectionStories[1];
    const restItems = areStoriesPresent && collectionStories.slice(2, 6);
    const slug = getSlug(collection, sections);
    // const adsId1 = "8314659081";
    // const adsId2 = "1964873157";

    const generateOtherStories = stories => {
      const children = stories.map((story, index) => {
        return (
          story && (
            <React.Fragment key={index}>
              <SmallHorizontalCard story={story} key={story.id} headlineLimit={60} headerType={18} />
            </React.Fragment>
          )
        );
      });
      return <div styleName="other-stories-container">{children}</div>;
    };

    return collectionStories.length > 0 ? (
      <div styleName="content-wrapper">
        <CustomHeadline text={collection.name} headerType={10} headerLevel={1} href={slug} />
        <div styleName="wrapper">
          <div styleName="top-stories-container">
            <div styleName="first-story">
              <CardImageLarge story={firstItem} headerType={17} headlineLimit={120} />
            </div>
            <div styleName="second-story">
              <SmallHorizontalCard story={secondItem} headlineLimit={60} headerType={18} />
            </div>
            <div styleName="second-group">{generateOtherStories(restItems)}</div>
            {this.state.width >= 992 && (
              <div styleName="dfp-ad-728x90">
                <DfpAd adtype="FPJ_Homepage_Middle_1_728x90" />
              </div>
            )}
          </div>
          {this.state.width > 992 && (
            <div>
              <div styleName="dfp-ad-300x250">
                {/* {this.dfpAd(adsId1)} */}
                <DfpAd adtype="FPJ_Homepage_Top_336x280" />
              </div>
              {/* <iframe
                width="300"
                height="255"
                scrolling="no"
                frameBorder="0"
                styleName="iframe-container"
                src="https://www.cricwaves.com/cricket/widgets/!/f1_zd/www.cricwaves.com/2/2/All/All/All/ban/w"
              /> */}
              <div styleName="dfp-ad-300x250">
                {/* {this.dfpAd(adsId2)} */}
                <DfpAd adtype="FPJ_Homepage_Middle_336x280" />
              </div>
            </div>
          )}
          {this.state.width <= 992 && (
            <React.Fragment>
              <div styleName="dfp-ad-300x250">
                <DfpAd adtype="FPJ_Homepage_Mobile_Middle_300x250" />
              </div>
              {/* <iframe
                width="300"
                height="255"
                scrolling="no"
                frameBorder="0"
                styleName="iframe-container"
                src="https://www.cricwaves.com/cricket/widgets/!/f1_zd/www.cricwaves.com/2/2/All/All/All/ban/w"
              /> */}
            </React.Fragment>
          )}
        </div>
      </div>
    ) : null;
  }
}

TopStoriesCollection.propTypes = {
  collection: object,
  sections: array
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(TopStoriesCollection);
